import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import errorCoffee from "../../../../assets/illustrations/nuvelor-error-coffee.webp";

export default function ErrorPage({ type = "500", errorText = "" }) {
  const { t } = useTranslation("errors");
  const is404 = type === "404";

  return (
    <div
      style={{
        padding: "64px 24px",
        minHeight: "60vh",
        textAlign: "center",
        color: "var(--interactive-fg)",
        fontWeight: 600,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={errorCoffee}
        alt={t("errorPage.imageAlt", { defaultValue: "NUVELOR coffee bunny" })}
        style={{
          width: 220,
          maxWidth: "100%",
          marginBottom: 24,
          borderRadius: "12px",
        }}
      />

      <h1 style={{ fontSize: 32, marginBottom: 16 }}>
        {is404
          ? t("errorPage.title404", { defaultValue: "404: Page not found" })
          : t("errorPage.title500", { defaultValue: "Oops! Something went wrong" })}
      </h1>

      <p style={{ color: "var(--text-muted)", maxWidth: 420, margin: "0 auto" }}>
        {is404
          ? t("errorPage.body404", { defaultValue: "Looks like you've gone to the wrong place 🐾" })
          : t("errorPage.body500", {
              defaultValue: "Looks like you have time to drink some coffee and try again later 🐾",
            })}
      </p>

      {errorText && (
        <div style={{ color: "var(--status-error-fg)", marginTop: 18, fontWeight: 500 }}>
          {errorText}
        </div>
      )}

      <Link
        to="/home"
        style={{
          marginTop: 22,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 42,
          padding: "0 18px",
          borderRadius: 14,
          background: "var(--control-bg)",
          border: "1px solid var(--interactive-border)",
          color: "var(--text-primary)",
          textDecoration: "none",
          boxShadow: "var(--shadow-control)",
        }}
      >
        {t("errorPage.goHome", { defaultValue: "Go to Home" })}
      </Link>
    </div>
  );
}
